module.exports = "http://cdn.realive.com.ua/src/views/player/documets/fibbadge/images/ava.png";